/**
 * Booking (popup) + Contact forms: submit via AJAX, then redirect to the Thank You page.
 */
document.addEventListener('submit', function (e) {
    const form = e.target.closest('.lykwow-ajax-form');
    if (!form || typeof window.LYKWOW_FORM === 'undefined') return;

    e.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const label = button ? button.querySelector('span') : null;
    const response = form.querySelector('.form-response-message');
    const originalLabel = label ? label.textContent : '';

    const showError = function (message) {
        if (!response) return;
        response.textContent = message;
        response.classList.add('is-error');
        response.style.display = 'block';
    };

    if (response) response.style.display = 'none';
    if (button) button.disabled = true;
    if (label) label.textContent = 'Sending…';

    const data = new FormData(form);
    data.append('action', 'lykwow_submit_form');
    data.append('nonce', window.LYKWOW_FORM.nonce);

    fetch(window.LYKWOW_FORM.ajaxUrl, { method: 'POST', body: data, credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (json) {
            if (json && json.success && json.data && json.data.redirect) {
                window.location.href = json.data.redirect;
                return;
            }
            throw new Error((json && json.data && json.data.message) || 'Something went wrong. Please try again.');
        })
        .catch(function (err) {
            showError(err.message || 'Something went wrong. Please try again.');
            if (button) button.disabled = false;
            if (label) label.textContent = originalLabel;
        });
});
